import { Injectable } from "@angular/core";
import { CookieService } from "ngx-cookie-service";
import { Utility } from "./_service/utility";
import { environment } from "../environments/environment";


@Injectable()
export class StorageService {




    constructor(
        private _cookie: CookieService,
        private _utility:Utility
    ) {


    }

    public SetCookie(str:string,value:any,days = 1,mins = null)
    {
        this.setCookie(str, value, days, mins);
    }
    ////
    public GetCookie(str){

        return this._cookie.get(str);
    }

    public GetConfig():any
    {
        if(environment.app)
        {
            return StorageService.QueryStringToJSON(this.GetItem("dn_config"));
        }
        else {
            var value = this._cookie.get("dn_config");
            return StorageService.QueryStringToJSON(value);//this.Get("dn_config");
        }

    }

    public SetConfig(value) {
        var config = this.GetConfig();
        config = Object.assign(config, value);
        //console.log(config)
        if (environment.app) {
            this.SetItem("dn_config", StorageService.JSONtoQueryString(config));
        }
        else {
            this.setCookie("dn_config", StorageService.JSONtoQueryString(config), 365);

        }

    }

    private static QueryStringToJSON(str) {
        var pairs = str ? str.split('&') : [];
        var result = {};
        pairs.forEach(function (pair) {
            pair = pair.split('=');
            var name = pair[0]
            var value = pair[1]
            if (name.length)
                if (result[name] !== undefined) {
                    if (!result[name].push) {
                        result[name] = [result[name]];
                    }
                    result[name].push(value || '');
                } else {
                    result[name] = value || '';
                }
        });
        return (result);
    }

    private static JSONtoQueryString(json) {
        var str = [];
        for (var p in json)
            if (json.hasOwnProperty(p)) {
                str.push(encodeURIComponent(p) + "=" + encodeURIComponent(json[p]));
            }
        return str.join("&");
    }

    /**
     * 获取一个暂存的数据，关闭浏览器后丢失
     * @param key
     */
    public GetSessionData(key = "") {

        var value = this._cookie.get("dn_temp");
        if (key) {
            return StorageService.QueryStringToJSON(value)[key]
        }
        return StorageService.QueryStringToJSON(value);
    }


    /**
     * 获取一个暂存的数据，关闭浏览器后丢失
     */
     public GetLocalSession() {
        return this.GetSessionData("__t");
    }
    public RemoveSessionData(key = "") {
        if (key) {
            var obj = {};
            obj[key] = "";
            this.SetSessionData(obj);
        }
        else {
            this.RemoveCookie("dn_temp");
        }
    }

    public SetSessionData(value) {
        var config = this.GetSessionData();
        config = Object.assign(config, value);
        let params: any = {};// new URLSearchParams();
        for (let key in config) {
            params[key] = config[key];
        }
        //console.log(value, '<<<<<<<<<<<')
        this.setCookie("dn_temp", StorageService.JSONtoQueryString(params), 0);
    }

    private setCookie(name, value, days, mins = null) {
        var expires = "";
        if (mins) {
            var date = new Date();
            date.setTime(date.getTime() + (mins * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        } else if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        var host = this._utility.GetHost("", true);

        var domain = "domain=" + (host && host.indexOf(".") == 0 ? host : "." + host);

        document.cookie = name + "=" + (value || "") + expires + "; path=/;" + domain;
        //console.log(name)

    }

    /**
     * 清除Cookie
     * @param key
     * @param value
     */
    public RemoveCookie(key: string,path=null,domain= null) {

        this._cookie.delete(key,path,domain);
    }
    static lsTest() {
        var test = 'test';
        try {
            localStorage.setItem(test, test);
            localStorage.removeItem(test);
            return true;
        } catch (e) {
            return false;
        }
    }

    public static IsLocalStorageAvailable = StorageService.lsTest();
    public SetItem(key, data) {
        if (StorageService.IsLocalStorageAvailable) {
            //   console.log("aa");
            localStorage.setItem(key, data);
        }
    }

    public GetItem(key) {
        if (StorageService.IsLocalStorageAvailable) {
            //console.log("aa");

            return localStorage.getItem(key);
        }
        return null;
    }

    public RemoveItem(key) {
        if (StorageService.IsLocalStorageAvailable) {
            localStorage.removeItem(key);
        }
    }



}